<app-data-set #dataSet [dataSource]="dataSource" [selectedDisplayFormat]="formatSelectedUserName" [rowId]="rowId">
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="serialNumber"
				[defaultFilterLabel]="filterLabels.serialNumber"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.userName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('userName')"
								data-automation-id="username-input"
								(ngModelChange)="dataSet.filter('userName', filterLabels.userName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.companyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('companyName')"
								data-automation-id="company-name-input"
								(ngModelChange)="dataSet.filter('companyName', filterLabels.companyName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.deviceLocation }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('deviceLocation')"
								data-automation-id="device-location-input"
								(ngModelChange)="dataSet.filter('deviceLocation', filterLabels.deviceLocation, $event)"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="2">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.serialNumber }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('serialNumber')"
								data-automation-id="serial-number-input"
								(ngModelChange)="dataSet.filter('serialNumber', filterLabels.serialNumber, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  Should be a drop-down list -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.eventType }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('eventType')"
								data-automation-id="event-type-input"
								(ngModelChange)="dataSet.filter('eventType', filterLabels.eventType, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (this.canGenerateEventHistoryReport) {
			<div *appActionGroup>
				<app-data-set-action-button
					label="Download"
					i18n-label="@@deviceAccessHistory-downloadReport"
					(click)="this.isDownloadReportDisabled ? null : generateEventHistoryReport()"
					data-automation-id="property-event-history-download-button"
					[isDisabled]="this.isDownloadReportDisabled"
				></app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (
				loadingService.isLoading(getPropertyEventHistoryLoadingKey) ||
				loadingService.isLoading(getEventHistoryReportLoadingKey) ||
				!finishedLoadingInitData
			) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSortActive="eventStart"
				matSortDirection="desc"
				matSort
				[hidden]="
					loadingService.isLoading(getPropertyEventHistoryLoadingKey) ||
					loadingService.isLoading(getEventHistoryReportLoadingKey) ||
					!finishedLoadingInitData
				"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="rowSelection">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						<app-data-set-table-row-selection [data]="row"></app-data-set-table-row-selection>
					</td>
				</ng-container>

				<ng-container matColumnDef="userName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-userName">User Name</th>
					<td mat-cell *matCellDef="let row">
						{{ row.entityRelationship?.childUser?.firstName }} {{ row.entityRelationship?.childUser?.lastName }}
					</td>
				</ng-container>

				<ng-container matColumnDef="companyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-workingFor">
						Working For
					</th>
					<td mat-cell *matCellDef="let row">{{ row.entityRelationship?.parentEntity?.name }}</td>
				</ng-container>

				<ng-container matColumnDef="deviceLocation">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-deviceLocation">
						Device Location
					</th>
					<td mat-cell *matCellDef="let row">{{ row.installationLocation?.name }}</td>
				</ng-container>

				<ng-container matColumnDef="serialNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-serialNumber">
						Serial Number
					</th>
					<td mat-cell *matCellDef="let row">{{ row.device.serialNumber }}</td>
				</ng-container>

				<ng-container matColumnDef="eventType">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-eventType">Event Type</th>
					<td mat-cell *matCellDef="let row">
						{{ row.eventName | eventTypeFormat: row.deviceRemovalAccessOptionsEnabled : row.metadata }}
					</td>
				</ng-container>

				<ng-container matColumnDef="eventStart">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-eventStart">
						Event Start
					</th>
					<td mat-cell *matCellDef="let row">
						<div class="date-time-container">
							<span>
								{{ row.utcStartDate | accessDateTime }}
							</span>
							@if (row.alarmStart === AlarmStatus.disarm) {
								<img
									src="assets/icons/icon-shield-with-x.svg"
									class="ajax-icon"
									[alt]="disarmedAlarmText"
									[title]="disarmedAlarmText"
								/>
							}
							@if (row.alarmStart === AlarmStatus.overriden) {
								<img
									src="assets/icons/icon-bell-crossed-out-orange.svg"
									class="ajax-icon bell-icon"
									[alt]="alarmOverrideText"
									[title]="alarmOverrideText"
								/>
							}
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="eventEnd">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-eventEnd">Event End</th>
					<td mat-cell *matCellDef="let row">
						<div class="date-time-container">
							<span>
								{{ row.utcEndDate | accessDateTime }}
							</span>
							@if (row.alarmEnd === AlarmStatus.arm) {
								<img
									src="assets/icons/icon-shield-checkmark-red.svg"
									class="ajax-icon"
									[alt]="armedAlarmText"
									[title]="armedAlarmText"
								/>
							}
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="endVisitType">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@propertyEventHistory-endVisitType">
						End Visit Type
					</th>
					<td mat-cell *matCellDef="let row">{{ row.endVisitType | endVisitTypeFormat }}</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row"></td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
